import type { IRecordTypeOverride } from '@platform/core/types';
import { withFieldOverride } from './patchFields';

/** Колір значення поля вибору чи статусу (ADR-023 `fields.<ключ>.colors`; null — повернути типовий). Чиста функція. */
export function setValueColor(patch: IRecordTypeOverride, field: string, value: string, color: string | null): IRecordTypeOverride {
  const colors = { ...(patch.fields?.[field]?.colors ?? {}) };
  if (color) colors[value] = color;
  else delete colors[value];
  return withFieldOverride(patch, field, { colors: Object.keys(colors).length ? colors : undefined });
}

/** Усі кольори поля — типові («Скинути до типових»). Чиста функція. */
export function resetValueColors(patch: IRecordTypeOverride, field: string): IRecordTypeOverride {
  return withFieldOverride(patch, field, { colors: undefined });
}
